import React, {useContext} from 'react';
import { User, Edit, Trash2 } from 'lucide-react';
import {UserContext} from "../../../contexts/AdminUserContext";
import PageWrapper  from "../../../components/pageWrapper/PageWrapper";


const Users = () => {
	const {pageUser} = useContext(UserContext);
	const getStatusInVietnamese = (status) => {
		switch (status) {
			case "Active":
				return "Hoạt động";
			case "Inactive":
				return "Không hoạt động";
			case "Published":
				return "Đã xuất bản";
			case "Draft":
				return "Bản nháp";
			default:
				return "Không xác định";
		}
	};
	return (
		<PageWrapper title="Danh sách khách hàng">
		<div className="bg-white min-h-[800px] rounded-lg shadow">
			<div className="p-6 border-b flex justify-between items-center">
				<h3 className="text-lg font-semibold text-gray-800">Danh sách khách hàng</h3>
			</div>
			<div className="p-6">
				<div className="overflow-x-auto">
					<table className="min-w-full divide-y divide-gray-200">
						<thead>
						<tr>
							<th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Họ và Tên
							</th>
							<th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Email
							</th>
							<th className="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
								Trang thái
							</th>
						</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
						{pageUser.items.map(({id,name,phoneNumber,email,role,status,imageUrl},index) => (
							<tr key={index} className="border-b bg-white divide-y divide-gray-200 hover:bg-gray-100">
								<td className="px-6 py-4 whitespace-nowrap">
									<div className="flex items-center">
										<div className="flex-shrink-0 h-10 w-10">
											{imageUrl ? (
												<img src={imageUrl} alt="User Avatar" className="h-10 w-10 rounded-full object-cover" />
											) : (
												<User className="h-10 w-10 rounded-full bg-gray-100 p-2" />
											)}
										</div>

										<div className="ml-4">
											<div className="text-sm font-medium text-gray-900">{name}</div>
										</div>
									</div>
								</td>
								<td className="px-6 py-4 whitespace-nowrap">
									<div className="text-sm text-gray-900">{email}</div>
								</td>
								<td className="px-6 py-4 whitespace-nowrap">
									<span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
										{getStatusInVietnamese(status)}
									</span>
								</td>
							</tr>
						))}
						</tbody>
					</table>
				</div>
			</div>
		</div>
		</PageWrapper>
	);
};

export default Users;